import moment from 'moment';
import { LogTTEPengetahuan } from '../../../../../entities/LogTTEPengetahuan';

/** Ambang job dianggap macet (sama dengan LogTandaTanganController::show). */
export const STALE_MINUTES = 5;

export type LogTteStatusKey =
  | 'processing'
  | 'stale'
  | 'done'
  | 'failed'
  | 'partial';

export interface LogTteStatus {
  key: LogTteStatusKey;
  label: string;
}

type LogCounter = Pick<
  LogTTEPengetahuan,
  'total' | 'berhasil' | 'gagal' | 'updated_at'
>;

/**
 * Menentukan status satu baris log TTE Pengetahuan.
 * Dasar penyelesaian adalah berhasil + gagal (bukan diproses), karena
 * `diproses` dinaikkan sebelum item selesai diproses.
 */
export const getStatusLogTte = (
  row: LogCounter,
  now: moment.Moment = moment()
): LogTteStatus => {
  const selesai = row.berhasil + row.gagal >= row.total;

  if (!selesai) {
    const stale = now.diff(moment(row.updated_at), 'minutes') >= STALE_MINUTES;
    return stale
      ? { key: 'stale', label: 'Job Tidak Terupdate' }
      : { key: 'processing', label: 'Sedang Diproses' };
  }
  if (row.gagal === 0) return { key: 'done', label: 'Selesai' };
  if (row.berhasil === 0) return { key: 'failed', label: 'Gagal' };

  return { key: 'partial', label: `Sebagian Gagal (${row.gagal})` };
};

/** Apakah ada baris yang masih berjalan (perlu polling). */
export const hasRunningLog = (rows: LogTTEPengetahuan[]): boolean =>
  rows.some((row) => getStatusLogTte(row).key === 'processing');
